import { DestroyRef, Directive, ElementRef, OnInit, inject } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { NgControl } from "@angular/forms";
import { fromEvent } from "rxjs";

@Directive({
    selector: "[appTrimInput]",
    standalone: false
})
export class TrimInputDirective implements OnInit {
  private elementRef = inject(ElementRef);
  private ngControl = inject(NgControl, { self: true });
  private readonly destroyRef = inject(DestroyRef);


  ngOnInit() {
      fromEvent(this.elementRef.nativeElement, "blur").pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
        const currentValue: string = this.ngControl.value?.toString();
        const whitespace = " ";
        if (
          currentValue.startsWith(whitespace) ||
          currentValue.endsWith(whitespace)
        ) {
          this.ngControl.control.patchValue(currentValue.trim());
        }
      });
  }
}
